import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import RootState from '@/store/RootState';
import filters from '@/store/filters';

Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  state: {
    version: '1.0.0',
  },
  modules: {
    filters,
  },
};

export default new Vuex.Store<RootState>(store);
